module.exports = __webpack_public_path__ + "img/linkedin.451b5069.svg";